"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../../../../../ui");
var _TransactionInfo = require("./TransactionInfo");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Card = function Card() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, null, /*#__PURE__*/_react.default.createElement(_ui.CardTitle, null, t('transactionDetails'))), /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "pt-0"
  }, /*#__PURE__*/_react.default.createElement(_TransactionInfo.TransactionInfo, null)));
};
exports.Card = Card;